import React, { useContext } from "react";
import inmoLogo2 from '../../assets/images/inmoLogo2.png';
import back from '../../assets/images/interface/back.svg';
import profileIcon from '../../assets/images/interface/person-circle-outline.svg';
import { PortionsContext } from "../../context/PortionsContext";
import { useHistory } from "react-router-dom";

export default function MapHeader({ goToProfile }) {
  const context = useContext(PortionsContext);
  const history = useHistory()
  return (
    <div className="home-header">
      <span onClick={() => {
        history.goBack();
        context.resetData();

      }} className="home-back">
        <img className="home-back-arrow" src={back} alt="back"></img>
        <span className="home-back-text">Atrás</span>
      </span>
      <img className="home-header-logo" src={inmoLogo2} alt="inmo"></img>
      <div onClick={goToProfile} className="home-header-profile">
        {localStorage.getItem("inmo_access_token") ? (
          <img src={profileIcon} width="32px" alt="profile"></img>
        ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontWeight: 600,
              }}
            >
              Ingresar
            </div>
          )}
      </div>
    </div>
  )
}
